/**
 * Motor de cálculo y dimensionamiento para determinar el plan ideal de Sysdent
 * Basado en las respuestas del diagnóstico de necesidades.
 */

export const PLANS_INFO = {
  BASIC: {
    id: "BASIC",
    nombre: "Plan Basic",
    tagline: "Ideal para consultorios independientes y profesionales que inician",
    badge: "Esencial",
    trialDays: 7,
    precioMes: 49,
    moneda: "S/",
    limiteUsuarios: 1,
    limitePacientes: 300,
    caracteristicas: [
      "1 Usuario Odontólogo",
      "Hasta 300 Pacientes activos",
      "Odontograma digital interactivo CIE-11",
      "Agenda de citas y calendario",
      "Presupuestos y notas clínicas básicas",
      "Soporte técnico por chat y email"
    ]
  },
  PRO: {
    id: "PRO",
    nombre: "Plan Pro",
    tagline: "Recomendado para consultorios en crecimiento y equipos colaborativos",
    badge: "Más Popular",
    popular: true,
    trialDays: 7,
    precioMes: 99,
    moneda: "S/",
    limiteUsuarios: 3,
    limitePacientes: 1000,
    caracteristicas: [
      "Hasta 3 Usuarios (Odontólogos y Asistentes)",
      "Hasta 1,000 Pacientes activos",
      "Recordatorios y confirmaciones automáticas por WhatsApp",
      "Gestión integral de presupuestos, pagos y abonos",
      "Historial de pagos y cuentas corrientes de pacientes",
      "Reportes de rendimiento y facturación clínica"
    ]
  },
  PREMIUM: {
    id: "PREMIUM",
    nombre: "Plan Premium",
    tagline: "La solución definitiva para clínicas dentales y equipos multi-doctor",
    badge: "Clínicas & Equipos",
    trialDays: 7,
    precioMes: 189,
    moneda: "S/",
    limiteUsuarios: 10,
    limitePacientes: "Ilimitados",
    caracteristicas: [
      "Hasta 10 Usuarios con roles y permisos avanzados",
      "Pacientes y prestaciones ilimitadas",
      "Módulo avanzado de WhatsApp marketing y recordatorios",
      "Cálculo de comisiones por odontólogo",
      "Control de gastos del consultorio y flujo de caja",
      "Soporte prioritario 24/7 y asesoría de onboarding"
    ]
  }
};

/**
 * Calcula el plan recomendado según los parámetros del diagnóstico.
 * 
 * @param {Object} params
 * @param {string} params.numDoctores - '1' | '2' | '3_5' | 'more_5'
 * @param {string} params.volumenPacientes - 'less_50' | '50_200' | 'more_200'
 * @param {string} [params.tipoEstablecimiento] - 'independiente' | 'clinica'
 * @returns {Object} Información completa del plan recomendado
 */
export const calculateRecommendedPlan = ({ numDoctores, volumenPacientes, tipoEstablecimiento }) => {
  // Regla 1: Si tiene más de 2 doctores o volumen de pacientes alto (> 200), o clínica grande -> PREMIUM
  if (
    numDoctores === "3_5" ||
    numDoctores === "more_5" ||
    volumenPacientes === "more_200" ||
    (tipoEstablecimiento === "clinica" && numDoctores !== "1")
  ) {
    return PLANS_INFO.PREMIUM;
  }

  // Regla 2: Si son 2 doctores, o 1 doctor pero con volumen medio (50-200) -> PRO
  if (
    numDoctores === "2" ||
    volumenPacientes === "50_200" ||
    tipoEstablecimiento === "clinica"
  ) {
    return PLANS_INFO.PRO;
  }

  // Regla 3: 1 doctor y volumen menor a 50 pacientes -> BASIC
  return PLANS_INFO.BASIC;
};
